<template>
    <div>
        <ValidationProvider
            v-slot="{ errors }"
            :rules="required ? { genericRequired: { allowFalse: false } } : ''"
            tag="section"
            :name="`checkbox-${name}`"
        >
            <label :for="name" class="form-checkbox">
                <input
                    :id="name"
                    v-model="checkboxValue"
                    class="form-checkbox__input"
                    type="checkbox"
                    :required="required"
                    :name="name"
                />
                <span v-if="gameRulesLink">
                    Ik ben 18 jaar of ouder en ga akkoord met de
                    <a :href="gameRulesLink" target="_blank">spelregels</a>.
                </span>
                <span v-else>{{ label }}</span>
                <button
                    v-if="info"
                    v-tooltip="{ content: info, trigger: 'hover click' }"
                    class="form-checkbox__info-button"
                    type="button"
                >
                    <span>i</span>
                </button>
            </label>
            <span v-if="errors[0]" class="form-checkbox__error-text">{{ errors[0] }}</span>
        </ValidationProvider>
    </div>
</template>

<script>
import './form-checkbox.scss';
import { ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('genericRequired', {
    ...required,
    message: 'Dit is een verplicht veld',
});

export default {
    name: 'FormCheckbox',
    components: { ValidationProvider },
    props: {
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        info: {
            type: String,
            required: false,
        },
        value: {
            required: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
        gameRulesLink: {
            type: String,
        },
    },
    data() {
        return {
            checkboxValue: this.value ?? false,
        };
    },
    watch: {
        checkboxValue: function(newVal) {
            this.$emit('input', newVal);
        },
    },
};
</script>
